import React, { useEffect, useMemo, useState } from 'react';
import { Container, Box, Button } from '@material-ui/core';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'react-simple-snackbar';
import styles from '../Clients/Clients.module.css';
import AddAccount from './AddAccount';
import { getAccountsByUser, deleteAccount } from '../../actions/accountActions';
import useAuthUser from '../../hooks/useAuthUser';

const Accounts = () => {
  const auth = useAuthUser()
  const dispatch = useDispatch()
  const { accounts, isLoading } = useSelector((state) => state.accounts)
  const [open, setOpen] = useState(false)
  const [currentId, setCurrentId] = useState(null)
  // eslint-disable-next-line no-unused-vars
  const [openSnackbar, closeSnackbar] = useSnackbar()

  useEffect(() => {
    const userId = auth?.result?._id || auth?.result?.googleId
    if (userId) {
      dispatch(getAccountsByUser({ search: userId }))
    }
  }, [auth, dispatch])

  const rows = useMemo(() => {
    return [...(accounts || [])].sort((a, b) => (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' }))
  }, [accounts])

  const handleEdit = (id) => {
    setCurrentId(id)
    setOpen(true)
  }

  const handleDelete = (id) => {
    dispatch(deleteAccount(id, openSnackbar))
  }

  const columns = [
    { field: 'name', headerName: 'Name', flex: 1.2, minWidth: 180 },
    { field: 'billingAddress', headerName: 'Billing Address', flex: 1.2, minWidth: 180 },
    { field: 'billingCity', headerName: 'City', flex: 0.8, minWidth: 130 },
    { field: 'billingState', headerName: 'State', flex: 0.4, minWidth: 90 },
    { field: 'billingZip', headerName: 'Zip', flex: 0.5, minWidth: 100 },
    { field: 'taxIdNumber', headerName: 'Tax ID', flex: 0.8, minWidth: 140 },
    { field: 'term', headerName: 'Term (Days)', type: 'number', flex: 0.5, minWidth: 120 },
    { field: 'phone', headerName: 'Phone', flex: 0.8, minWidth: 140 },
    { field: 'email', headerName: 'Email', flex: 1.1, minWidth: 180 },
    {
      field: 'actions',
      headerName: 'Actions',
      sortable: false,
      filterable: false,
      width: 180,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" style={{ gap: 8 }}>
          <Button
            style={{color: 'white', backgroundColor: 'rgb(25, 118, 210)', marginRight: 10}}
            onClick={(e) => { e.stopPropagation(); handleEdit(params.row._id); }}
            variant="contained"
            size="small"
          >
            Edit
          </Button>
          <Button
            style={{color: 'white', backgroundColor: 'red'}}
            onClick={(e) => { e.stopPropagation(); handleDelete(params.row._id); }}
            variant="contained"
            size="small"
          >
            Delete
          </Button>
        </Box>
      ),
    },
  ]

  return (
    <div className={styles.pageLayout}>
      <Container style={{ width: '90%', maxWidth: 1400 }}>
        <div className={styles.buttons}>
          <h1>Accounts</h1>
          <button
            className={styles.btn}
            onClick={() => { setCurrentId(null); setOpen((prev) => !prev) }}
          >
            Add Account
          </button>
        </div>
        <DataGrid
          autoHeight
          loading={isLoading}
          rows={rows}
          getRowId={(row) => row._id}
          columns={columns}
          pageSize={25}
          rowsPerPageOptions={[10, 25, 50, 100]}
          components={{ Toolbar: GridToolbar }}
          componentsProps={{ toolbar: { showQuickFilter: true, quickFilterProps: { debounceMs: 300 } } }}
          sx={{
            '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '6px' },
            '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '8px' },
            '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '12px' },
          }}
          onRowDoubleClick={(params) => handleEdit(params.id)}
        />
      </Container>
      <AddAccount open={open} setOpen={setOpen} currentId={currentId} setCurrentId={setCurrentId} />
    </div>
  );
};

export default Accounts;
